export default {
	data() {
		return {
			
		}
	},
	methods: {
    	getValidationClass (fieldName) {
            const field = this.$v.form[fieldName]
            if (field && !this.isLoading) {
                return {
                    'is-invalid': (field.$invalid && field.$dirty) || this.serverErrors[fieldName]
                }
            }
        },
        clearErrors(name) {
        	if (name) {
        		Vue.delete(this.serverErrors, name);
        	}
        },
        validateForm () {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.saveData();
            }
        },
    }
};